// @ts-nocheck

import { createSelector } from 'reselect';

import { selectIsBoomVisible } from '../../modules/boom/selectors/runtime.selector';
import { selectIsGREnabledAndNotForbidden } from '../../modules/gift-race/selectors/runtime.selector';
import { isGrids as isPathGrids } from '../../modules/grids/utils/routes';
import { selectIsKLEnabled } from '../../modules/koh-lanta/selectors/runtime';
import { selectIsMPEnabled } from '../../modules/monopoly/selectors/computed/runtime';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserDidReceivedUserData, selectUserPromotionStatus } from '../../selectors/user/userPrimary.selector';
import { type Selector } from '../../types/selectors';
import { TabBarNavigationTypes } from '../../types/tabBar';
import { type TabBarNavigationType } from '../../types/tabBar';
import { getShouldEnlightOperationsDisplay } from '../../utils/operations';

const selectSportsBettingItemIds: Selector<Array<TabBarNavigationType>> = createSelector(
  [
    selectIsKLEnabled,
    selectIsGREnabledAndNotForbidden,
    selectIsMPEnabled,
    selectIsBoomVisible,
    selectRuntimeLicence,
    selectUserPromotionStatus,
    selectUserDidReceivedUserData,
  ],
  (isKLEnabled, isGREnabled, isMPEnabled, isBoomEnabled, licence, promotionStatus, didReceivedUserData) => {
    const itemIds = [
      TabBarNavigationTypes.HOME,
      TabBarNavigationTypes.SPORTS,
      TabBarNavigationTypes.LIVE,
      TabBarNavigationTypes.MY_BETS,
      TabBarNavigationTypes.EXTRAS,
    ];

    const showOperationItem = getShouldEnlightOperationsDisplay(licence, promotionStatus, didReceivedUserData);

    if (isMPEnabled && showOperationItem) {
      itemIds.push(TabBarNavigationTypes.MONOPOLY);
    } else if (isGREnabled && showOperationItem) {
      itemIds.push(TabBarNavigationTypes.GIFT_RACE);
    } else if (isKLEnabled && showOperationItem) {
      itemIds.push(TabBarNavigationTypes.KOH_LANTA);
    } else if (isBoomEnabled && showOperationItem) {
      itemIds.push(TabBarNavigationTypes.BOOM);
    }

    return itemIds;
  },
);

const selectTabBarItemIds: Selector<Array<TabBarNavigationType>> = createSelector(
  [selectSportsBettingItemIds, (_, { pathname }) => isPathGrids(pathname)],
  (sportsBettingItemIds, isGrids) => {
    let itemIds = null;

    if (isGrids) {
      itemIds = [
        TabBarNavigationTypes.HOME,
        TabBarNavigationTypes.GRIDS,
        TabBarNavigationTypes.BASKET,
        TabBarNavigationTypes.GRIDS_HISTORY,
      ];
    }

    return itemIds ?? sportsBettingItemIds;
  },
);

type NavigationTabBarPropsType = {
  itemIds: Array<TabBarNavigationType>;
};

const selectNavigationTabBarProps: Selector<NavigationTabBarPropsType> = createSelector(
  [selectTabBarItemIds],
  (itemIds) => ({
    itemIds,
  }),
);

export default selectNavigationTabBarProps;
